import { Link } from "wouter";
import { PRODUCT_NAME, PRODUCT_NAME_ZH } from "@/lib/publicLinks";
import { openNativeApp } from "@/lib/authEmailLinks";

/** Thematic verified-email illustration — envelope + check + coin (MoneyTrack). */
function VerifiedHeroArt() {
  return (
    <div className="relative mx-auto w-44 h-44 sm:w-52 sm:h-52 shrink-0">
      <svg
        viewBox="0 0 180 180"
        className="w-full h-full drop-shadow-[5px_5px_0_rgba(0,0,0,0.9)] dark:drop-shadow-none"
        aria-hidden
      >
        <ellipse cx="90" cy="152" rx="52" ry="11" fill="#86efac" opacity="0.5" />
        {/* tilted back card */}
        <rect
          x="34"
          y="42"
          width="96"
          height="84"
          rx="20"
          fill="#bbf7d0"
          stroke="#111"
          strokeWidth="3"
          transform="rotate(-7 82 84)"
        />
        {/* envelope body */}
        <rect x="48" y="52" width="100" height="78" rx="14" fill="#fff" stroke="#111" strokeWidth="3" />
        {/* envelope flap */}
        <path d="M48 66 L98 98 L148 66" fill="none" stroke="#111" strokeWidth="3" strokeLinejoin="round" />
        <path d="M48 66 L98 40 L148 66" fill="#6ee7b7" stroke="#111" strokeWidth="3" strokeLinejoin="round" />
        {/* check badge */}
        <circle cx="128" cy="118" r="22" fill="#10b981" stroke="#111" strokeWidth="3" />
        <path
          d="M118 118 l7 7 14 -16"
          fill="none"
          stroke="#fff"
          strokeWidth="4.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* coin accent */}
        <circle cx="58" cy="48" r="15" fill="#fbbf24" stroke="#111" strokeWidth="3" />
        <circle cx="58" cy="48" r="8" fill="none" stroke="#111" strokeWidth="2" />
        <text x="58" y="52.5" textAnchor="middle" fontSize="11" fontWeight="800" fill="#111">
          $
        </text>
        {/* sparkles */}
        <path
          d="M150 48 l2 5 5 2 -5 2 -2 5 -2 -5 -5 -2 5 -2 z"
          fill="#34d399"
          stroke="#111"
          strokeWidth="1.4"
        />
        <path
          d="M42 120 l1.6 3.8 3.8 1.6 -3.8 1.6 -1.6 3.8 -1.6 -3.8 -3.8 -1.6 3.8 -1.6 z"
          fill="#fbbf24"
          stroke="#111"
          strokeWidth="1.2"
        />
      </svg>
    </div>
  );
}

/**
 * Email confirmation landing (legal-public only).
 */
export default function AuthVerified() {
  return (
    <div className="min-h-[100dvh] bg-background flex flex-col pt-safe pb-safe">
      <main className="flex-1 max-w-md mx-auto w-full px-5 py-8 sm:py-12 flex flex-col justify-center gap-6">
        <VerifiedHeroArt />

        <header className="space-y-2 text-center">
          <p className="text-[10px] font-bold tracking-wide text-muted-foreground uppercase">
            {PRODUCT_NAME}
          </p>
          <h1 className="text-2xl sm:text-3xl font-black text-foreground">Email 已驗證成功</h1>
          <p className="text-sm font-medium text-muted-foreground leading-relaxed">
            請回到 {PRODUCT_NAME_ZH} App，用同一個 Email 與密碼登入即可。
          </p>
        </header>

        <div className="space-y-2.5">
          <button
            type="button"
            onClick={() => openNativeApp("auth/verified")}
            className="flex items-center justify-center w-full h-12 rounded-xl border-2 border-black dark:border-white/20 bg-black text-white dark:bg-white dark:text-black font-bold text-sm shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-none hover:translate-x-px hover:translate-y-px hover:shadow-none transition-all"
          >
            打開 {PRODUCT_NAME} App
          </button>
          <Link
            href="/"
            className="flex items-center justify-center w-full h-11 rounded-xl border-2 border-black dark:border-white/20 bg-white dark:bg-zinc-900 font-bold text-sm shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-none hover:translate-x-px hover:translate-y-px hover:shadow-none transition-all"
          >
            回到說明首頁
          </Link>
        </div>
      </main>
    </div>
  );
}
